// extracted by mini-css-extract-plugin
module.exports = {"save":"index_save_1YOnW","cancel":"index_cancel_qpC6-","display":"index_display_aIPNs"};